import { Outlet } from "react-router-dom";
import Topbar from "../Topbar/Topbar";
import styles from "./dashboardLayout.module.css";
import { Copyright } from "lucide-react";
import CopyRight from "../../CopyRight/CopyRight";

export default function DashboardLayout() {
  return (
    <div className={styles.layoutRoot}>
      <Topbar />
      <main className={styles.content}>
        <Outlet />
      </main>
      <CopyRight />
    </div>
  );
}
